<form [formGroup]="agencyForm" class="mb-5 rounded-md border border-[#ebedf2] bg-white p-4 dark:border-[#191e3a] dark:bg-[#0e1726]">
  <h6 class="mb-5 text-lg font-bold">{{ "user_profile.agency_info" | translate }}</h6>

  <div class="flex flex-col sm:flex-row">
    <div class="mb-5 w-full sm:w-2/12 ltr:sm:mr-4 rtl:sm:ml-4">
      <!-- Icon representation for Agency/Company -->
      <div class="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-primary/10 text-primary md:h-32 md:w-32">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="h-10 w-10 md:h-16 md:w-16"
        >
          <rect x="2" y="2" width="20" height="20" rx="2" ry="2" />
          <path d="M7 21v-4a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v4" />
          <path d="M8 7h8" />
          <path d="M8 11h8" />
        </svg>
      </div>
    </div>

    <div class="grid flex-1 grid-cols-1 gap-5 sm:grid-cols-2">
      <!-- Name -->
      <div [ngClass]="agencyForm.controls['name'].touched ? (agencyForm.controls['name'].errors ? 'has-error' : 'has-success') : ''">
        <label class="form-label" for="name">{{ "user_profile.agency_name" | translate }}</label>
        <input
          id="name"
          type="text"
          [ngClass]="!editMode ? 'form-input cursor-not-allowed disabled:pointer-events-none disabled:bg-[#eee] dark:disabled:bg-[#1b2e4b]' : 'form-input'"
          [placeholder]="'user_profile.enter_agency_name' | translate"
          class="form-input"
          formControlName="name"
        />
      </div>

      <!-- Email -->
      <div [ngClass]="agencyForm.controls['email'].touched ? (agencyForm.controls['email'].errors ? 'has-error' : 'has-success') : ''">
        <label class="form-label" for="email">{{ "user_profile.agency_email" | translate }}</label>
        <input
          id="email"
          type="email"
          [ngClass]="!editMode ? 'form-input cursor-not-allowed disabled:pointer-events-none disabled:bg-[#eee] dark:disabled:bg-[#1b2e4b]' : 'form-input'"
          [placeholder]="'user_profile.enter_agency_email' | translate"
          class="form-input"
          formControlName="email"
        />
      </div>

      <!-- City -->
      <div [ngClass]="agencyForm.controls['city'].touched ? (agencyForm.controls['city'].errors ? 'has-error' : 'has-success') : ''">
        <label class="form-label" for="city">{{ "user_profile.city" | translate }}</label>
        <input
          id="city"
          type="text"
          [ngClass]="!editMode ? 'form-input cursor-not-allowed disabled:pointer-events-none disabled:bg-[#eee] dark:disabled:bg-[#1b2e4b]' : 'form-input'"
          [placeholder]="'user_profile.enter_city' | translate"
          class="form-input"
          formControlName="city"
        />
      </div>

      <!-- Postal Code -->
      <div [ngClass]="agencyForm.controls['postalCode'].touched ? (agencyForm.controls['postalCode'].errors ? 'has-error' : 'has-success') : ''">
        <label class="form-label" for="postalCode">{{ "user_profile.postal_code" | translate }}</label>
        <input
          id="postalCode"
          type="text"
          [ngClass]="!editMode ? 'form-input cursor-not-allowed disabled:pointer-events-none disabled:bg-[#eee] dark:disabled:bg-[#1b2e4b]' : 'form-input'"
          [placeholder]="'user_profile.enter_postal_code' | translate"
          class="form-input"
          formControlName="postalCode"
        />
      </div>

      <!-- Address -->
      <div [ngClass]="agencyForm.controls['companyAddress'].touched ? (agencyForm.controls['companyAddress'].errors ? 'has-error' : 'has-success') : ''">
        <label class="form-label" for="companyAddress">{{ "user_profile.company_address" | translate }}</label>
        <input
          id="companyAddress"
          type="text"
          [ngClass]="!editMode ? 'form-input cursor-not-allowed disabled:pointer-events-none disabled:bg-[#eee] dark:disabled:bg-[#1b2e4b]' : 'form-input'"
          [placeholder]="'user_profile.enter_company_address' | translate"
          class="form-input"
          formControlName="companyAddress"
        />
      </div>

      <!-- Email -->
      <div [ngClass]="agencyForm.controls['companyEmail'].touched ? (agencyForm.controls['companyEmail'].errors ? 'has-error' : 'has-success') : ''">
        <label class="form-label" for="companyEmail">{{ "user_profile.company_email" | translate }}</label>
        <input
          id="companyEmail"
          type="email"
          [ngClass]="!editMode ? 'form-input cursor-not-allowed disabled:pointer-events-none disabled:bg-[#eee] dark:disabled:bg-[#1b2e4b]' : 'form-input'"
          [placeholder]="'user_profile.enter_company_email' | translate"
          class="form-input"
          formControlName="companyEmail"
        />
      </div>

      <!-- Phone -->
      <div [ngClass]="agencyForm.controls['companyPhone'].touched ? (agencyForm.controls['companyPhone'].errors ? 'has-error' : 'has-success') : ''">
        <label class="form-label" for="companyPhone">{{ "user_profile.company_phone" | translate }}</label>
        <input
          id="companyPhone"
          type="text"
          [ngClass]="!editMode ? 'form-input cursor-not-allowed disabled:pointer-events-none disabled:bg-[#eee] dark:disabled:bg-[#1b2e4b]' : 'form-input'"
          [placeholder]="'user_profile.enter_company_phone' | translate"
          class="form-input"
          formControlName="companyPhone"
        />
      </div>

      <!-- Account Number -->
      <div [ngClass]="agencyForm.controls['accountNumber'].touched ? (agencyForm.controls['accountNumber'].errors ? 'has-error' : 'has-success') : ''">
        <label class="form-label" for="accountNumber">{{ "user_profile.account_number" | translate }}</label>
        <input
          id="accountNumber"
          type="text"
          [ngClass]="!editMode ? 'form-input cursor-not-allowed disabled:pointer-events-none disabled:bg-[#eee] dark:disabled:bg-[#1b2e4b]' : 'form-input'"
          [placeholder]="'user_profile.enter_account_number' | translate"
          class="form-input"
          formControlName="accountNumber"
        />
      </div>

      <!-- PIB -->
      <div [ngClass]="agencyForm.controls['pib'].touched ? (agencyForm.controls['pib'].errors ? 'has-error' : 'has-success') : ''">
        <label class="form-label" for="pib">{{ "user_profile.pib" | translate }}</label>
        <input
          id="pib"
          type="text"
          [ngClass]="!editMode ? 'form-input cursor-not-allowed disabled:pointer-events-none disabled:bg-[#eee] dark:disabled:bg-[#1b2e4b]' : 'form-input'"
          [placeholder]="'user_profile.enter_pib' | translate"
          class="form-input"
          formControlName="pib"
        />
      </div>

      <!-- MB -->
      <div [ngClass]="agencyForm.controls['mb'].touched ? (agencyForm.controls['mb'].errors ? 'has-error' : 'has-success') : ''">
        <label class="form-label" for="mb">{{ "user_profile.mb" | translate }}</label>
        <input
          id="mb"
          type="text"
          [ngClass]="!editMode ? 'form-input cursor-not-allowed disabled:pointer-events-none disabled:bg-[#eee] dark:disabled:bg-[#1b2e4b]' : 'form-input'"
          [placeholder]="'user_profile.enter_mb' | translate"
          class="form-input"
          formControlName="mb"
        />
      </div>

      <!-- IBAN -->
      <div [ngClass]="agencyForm.controls['iban'].touched ? (agencyForm.controls['iban'].errors ? 'has-error' : 'has-success') : ''">
        <label class="form-label" for="iban">{{ "user_profile.iban" | translate }}</label>
        <input
          id="iban"
          type="text"
          [ngClass]="!editMode ? 'form-input cursor-not-allowed disabled:pointer-events-none disabled:bg-[#eee] dark:disabled:bg-[#1b2e4b]' : 'form-input'"
          [placeholder]="'user_profile.enter_iban' | translate"
          class="form-input"
          formControlName="iban"
        />
      </div>

      <!-- SWIFT -->
      <div [ngClass]="agencyForm.controls['swift'].touched ? (agencyForm.controls['swift'].errors ? 'has-error' : 'has-success') : ''">
        <label class="form-label" for="swift">{{ "user_profile.swift" | translate }}</label>
        <input
          id="swift"
          type="text"
          [ngClass]="!editMode ? 'form-input cursor-not-allowed disabled:pointer-events-none disabled:bg-[#eee] dark:disabled:bg-[#1b2e4b]' : 'form-input'"
          [placeholder]="'user_profile.enter_swift' | translate"
          class="form-input"
          formControlName="swift"
        />
      </div>

      <!-- Actions -->
      <div class="mt-3 sm:col-span-2">
        <div class="flex">
          <button *ngIf="editMode" type="button" class="btn btn-primary mr-2" (click)="saveChanges()" [disabled]="isLoading">
            <ng-container *ngIf="isLoading; else saveLabel">
              <span class="inline-block h-3 w-3 animate-ping rounded-full bg-white ltr:mr-4 rtl:ml-4"></span>
              {{ "loading" | translate }}
            </ng-container>
            <ng-template #saveLabel>
              <span>{{ "user_profile.save" | translate }}</span>
            </ng-template>
          </button>

          <button *ngIf="editMode" type="button" class="btn btn-danger" (click)="discardChanges()">
            {{ "user_profile.discard" | translate }}
          </button>

          <button *ngIf="!editMode" type="button" class="btn btn-primary" (click)="toggleEdit()">
            {{ "user_profile.edit" | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</form>
<app-configuration-e-invoice></app-configuration-e-invoice>
